/* @flow */

/**
 * Detects whether an Object has any properties
 *
 * @method isEmptyObject
 * @param {Object} obj
 * @return {boolean}
 */

const isEmptyObject: Function = (obj): boolean => {
  for (const key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      return false;
    }
  }

  return true;
};

export default isEmptyObject;
